// angular
// 	.module("HeroPRO")
// 	.controller("AddUserController", addUserController);

import './addUser.scss';
import _ from 'lodash';

/* @ngInject */
export default function addUserController($scope, $rootScope, $uibModalInstance, AccountsFactory, OfficesFactory, HPRoles, LicensesFactory) {
    const vm = this;

    vm.defaultText = 'Choose One';
    vm.contentShown = 'addUserInProgress';
    vm.submitted = 'false';
    vm.hasOneLocation = false;
    vm.disableUI = true;
    vm.saving = false;
    vm.isAddLocationButtonVisible = false;

    vm.user = {
        FirstName: '',
        MiddleInitial: null,
        LastName: '',
        Suffix: null,
        Role: null,
        ContractorLocationIds: [],
    };

    vm.contact = {
        Email: '',
        PhoneNumber: '',
        Extension: '',
    };

    vm.defaultLocation = {
        LocationNickname: vm.defaultText,
        ContractorId: -1,
    };


    vm.availableOffices = [];

    vm.states = [];

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.closeModal = function () {
        let result = false;

        if (vm.contentShown === 'addUserSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
    };

    vm.submitNewUser = function () {
        vm.submitted = 'true';
        vm.validateLocationState();
        if (vm.hasLocationState()) {
            vm.validateLocations();
        }

        if (vm.addUserForm.$valid && vm.contact.PhoneNumber !== '' && vm.saving !== true) {
            vm.saving = true;
            const data = {
                FirstName: vm.user.FirstName,
                LastName: vm.user.LastName,
                Email: vm.contact.Email,
                Phone: vm.contact.PhoneNumber,
                PhoneExt: vm.contact.Extension,
                RoleId: vm.user.Role.RoleId,
                CSLBTitleId: vm.user.TitleId,
                CSLBMiddleInitial: vm.user.MiddleInitial,
                CSLBSuffix: vm.user.Suffix,
                ContractorLocationIds: prepLocationsForSave(),
            };
            saveNewUser(data);
        }
    };

    vm.addLocation = function () {
        vm.selectedLocations.push({
            selectedState: vm.defaultText,
            selectedLocation: vm.defaultLocation,
        });

        displayAddAdditionalLocation();
    };

    vm.stateClicked = function (state, index) {
        let originalState = null,
            originalLocation = null;

        if (vm.selectedLocations[index].selectedState !== vm.defaultText) {
            // (ajt - 8/8/2016) Mark original Location unselected and clear location from selected locations
            originalState = _.find(vm.availableOffices, office => office.State === vm.selectedLocations[index].selectedState);
            originalLocation = _.find(originalState.Locations, origLoc => origLoc.LocationNickname === vm.selectedLocations[index].selectedLocation.LocationNickname);

            if (originalLocation !== undefined) {
                originalLocation.selectedRow = -1;
            }

            vm.selectedLocations[index].selectedLocation = vm.defaultLocation;
        }

        vm.selectedLocations[index].selectedState = state;

        checkIfStateHasLocation(originalState);
    };

    vm.locationClicked = function (location, index) {
        let originalLocation = null;

        // (ajt - 8/8/2016) Find and store the last location
        if (vm.selectedLocations[index].selectedLocation.LocationNickname !== vm.defaultText) {
            originalLocation = vm.selectedLocations[index].selectedLocation;
        }

        vm.selectedLocations[index].selectedLocation = location;

        let selectedState = _.find(vm.availableOffices, office => office.State === vm.selectedLocations[index].selectedState);

        // (ajt - 8/8/2016) Mark new location selected
        const selectedLoc = _.find(selectedState.Locations, loc => loc.LocationNickname === location.LocationNickname);

        selectedLoc.selectedRow = index;

        checkIfStateHasLocation(selectedState);

        // (ajt - 8/8/2016) Check if old location needs to be unselected
        if (originalLocation !== null) {
            selectedState = _.find(vm.availableOffices, office => office.State === originalLocation.State);

            const removedLoc = _.find(selectedState.Locations, loc => loc.LocationNickname === originalLocation.LocationNickname);

            removedLoc.selectedRow = -1;
        }

        displayAddAdditionalLocation();
        vm.validateLocations();
    };

    vm.removeLocation = function (location, index) {
        let originalState = null,
            originalLocation = null;

        // (ajt - 8/8/2016) Unselect previously selected location
        originalState = _.find(vm.availableOffices, office => office.State === vm.selectedLocations[index].selectedState);

        originalLocation = _.find(originalState.Locations, origLoc => origLoc.LocationNickname === vm.selectedLocations[index].selectedLocation.LocationNickname);
        originalLocation.selectedRow = -1;

        checkIfStateHasLocation(originalState);

        vm.selectedLocations = _.without(vm.selectedLocations, _.findWhere(vm.selectedLocations, location));

        displayAddAdditionalLocation();
    };

    // (ajt 5/31/2016) Add validation method to check if a User Role is not selected.
    vm.validateUserRole = function () {
        return vm.user.Role === null || vm.user.Role.Name === 'DEFAULT';
    };

    vm.hasLocationState = function () {
        if (vm.selectedLocations && vm.selectedLocations[0].selectedState !== vm.defaultText) {
            return true;
        }

        return false;
    };

    vm.validateLocationState = function () {
        if (!vm.isAllOfficesDisplayed) {
            if (vm.hasLocationState()) {
                vm.addUserForm.$setValidity('nolocationstate', true);
            } else {
                vm.addUserForm.$setValidity('nolocationstate', false);
            }
        }
    };

    vm.hasLocations = function () {
        if (vm.selectedLocations && vm.selectedLocations[0].selectedLocation.ContractorId !== -1) {
            return true;
        }

        return false;
    };

    vm.validateLocations = function () {
        if (!vm.isAllOfficesDisplayed) {
            if (vm.hasLocations()) {
                vm.addUserForm.$setValidity('nolocation', true);
            } else {
                vm.addUserForm.$setValidity('nolocation', false);
            }
        }
    };

    vm.checkRemainingAvailableLocations = function () {
        let numUnselected = 0;
        _.each(vm.availableOffices, (office) => {
            const unselectedLocations = _.filter(office.Locations, loc => loc.selectedRow === -1);
            numUnselected += unselectedLocations.length;
        });

        return numUnselected > 0;
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions           =
	 ======================================== */
    function init() {
        getOfficeLocations();
        getOrganizationLicense();
    }

    function getOfficeLocations() {
        vm.loadingOffices = true;
        let locations = [],
            states = [];
        OfficesFactory.getOffices().then((response) => {
            _.each(response.data.Data, (location) => {
                locations.push({
                    ContractorId: location.ContractorId,
                    LocationNickname: location.LocationNickname,
                    State: location.State,
                    selectedRow: -1,
                });
            });

            locations = _.sortBy(locations, location => location.LocationNickname.toLowerCase());

            states = _.sortBy(_.pluck(_.uniq(locations, location => location.State), 'State'));

            _.each(states, (state) => {
                vm.availableOffices.push({
                    State: state.toString(),
                    Locations: _.filter(locations, location => location.State === state),
                    hasLocations: true,
                });
            });
            setInitialSelectedLocation();
        });
    }

    function getOrganizationLicense() {
        // Find the california license
        LicensesFactory.getLicenses().then((response) => {
            const californiaLicense = _.findWhere(response.data.Data.Licenses, { OrganizationLicenseTypeId: 1 });
            if (californiaLicense !== undefined) {
                vm.licenseNumber = californiaLicense.LicenseNumber;
            }
        });
    }

    // (ajt - 8/8/2016) Recheck state to see if locations are available after state change.
    function checkIfStateHasLocation(state) {
        if (state !== undefined && state !== null) {
            const availLocations = _.find(state.Locations, loc => loc.selectedRow === -1);
            if (availLocations === undefined) {
                state.hasLocations = false;
            } else {
                state.hasLocations = true;
            }
        }
    }

    function setInitialSelectedLocation() {
        vm.selectedLocations = [
            {
                selectedState: vm.defaultText,
                selectedLocation: vm.defaultLocation,
            },
        ];
    }

    function toggleDisabledState(role) {
        if (vm.addUserForm !== undefined && vm.addUserForm !== null) {
            vm.addUserForm.$setPristine();
        }
        if (role === null || role.RoleId === -1) {
            vm.disableUI = true;
        } else {
            vm.disableUI = false;
        }
    }

    function displayAllOffices() {
        if (vm.user.Role !== null && vm.user.Role !== undefined && vm.user.Role.RoleId !== undefined && vm.user.Role.RoleId !== null) {
            const companyRole = _.find(HPRoles, role => role.roleId === vm.user.Role.RoleId && role.rank === 1);
            if (companyRole !== undefined && companyRole !== null && !vm.hasOneLocation) {
                vm.isAllOfficesDisplayed = true;
                vm.addUserForm.$setValidity('nolocation', true);
            } else {
                vm.isAllOfficesDisplayed = false;
            }
        }
    }

    function prepLocationsForSave() {
        const currentSelectedLocations = [];

        if (vm.isAllOfficesDisplayed) {
            currentSelectedLocations.push(vm.availableOffices[0].Locations[0].ContractorId);
        } else {
            _.each(vm.selectedLocations, (location) => {
                if (location.selectedLocation.ContractorId !== undefined && location.selectedLocation.ContractorId !== null && location.selectedLocation.ContractorId !== -1) {
                    currentSelectedLocations.push(location.selectedLocation.ContractorId);
                }
            });
        }
        return currentSelectedLocations;
    }

    function saveNewUser(data) {
        AccountsFactory.addUser(data).then((response) => {
            vm.saving = false;
            if ((response.data !== null || response.data !== undefined) && response.data.ResultCode === 2) {
                $rootScope.$broadcast('EmailInUse');
            } else if (response.data === null || response.data === undefined || response.data.ResultCode === 1) {
                vm.successText = `${vm.user.FirstName} ${vm.user.LastName} has been created successfully.`;
                vm.secondaryText = `${vm.user.FirstName} will get an email from us to finish their account setup.`;
                vm.contentShown = 'addUserSuccess';

                // ProTip
            }
        });
    }

    function displayAddAdditionalLocation() {
        if (vm.selectedLocations.length > 1) {
            vm.isAddLocationButtonVisible = vm.selectedLocations[vm.selectedLocations.length - 1].selectedLocation.ContractorId !== -1 && !vm.isAllOfficesDisplayed && !vm.hasOneLocation;
        } else {
            vm.isAddLocationButtonVisible = vm.selectedLocations[0].selectedLocation.ContractorId !== -1 && !vm.isAllOfficesDisplayed && !vm.hasOneLocation;
        }
    }

    $scope.$watch(() => vm.user.Role, (val) => {
        displayAllOffices();
        toggleDisabledState(val);
        vm.submitted = 'false';
    });
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/addUser/addUserController.js